import React from "react";

export default function Marquee() {
  const text = "SEAL TODAY, SAFE TOMORROW";
  return (
    <div className="bg-royal py-5 overflow-hidden border-y border-white/10" data-testid="marquee">
      <div className="flex whitespace-nowrap animate-marquee">
        {Array.from({ length: 8 }).map((_, i) => (
          <span key={i} className="font-display font-extrabold text-2xl md:text-4xl text-white/90 mx-8 flex items-center gap-8">
            {text}
            <span className="text-white/40">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
